import api from "api";

export const fetchSocialNetworks = () => api.get("/social_networks");
